// Presentation metadata only. Calculations remain in the shared API.
const config = Object.freeze({
  endpoint: '/api/calculators/annuity-risk/calculate',
  fields: ['currentAge', 'currentFundValue', 'withdrawalAmount', 'taxFreeCashIncluded', 'otherAnnualIncome', 'expectedDeathAge', 'taxYear'],
  example: [55, 200000, 20000, 0, 35000, 87, '2026/27'],
  subject: 'illustration', initialMessage: 'Enter the pension and withdrawal details to see the illustration.',
  validationMessage: 'Enter a finite numeric value.', successMessage: 'Illustration calculated using historical annuity rates and the corrected tax comparison.',
  outputLabels: { exhaustionYears: 'Years until exhaustion', exhaustionAge: 'Age at exhaustion', guardrailIncomeToExpectedAge: 'Income until expected age' }
});
export default config;
